import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { SegmentCreateInput } from "@colab/shared";

export type CreateSegmentResponse = { id: string };

// POST /api/settings/segments
//
// Replaces revalidatePath("/admin/settings/segments") from
// /app/admin/settings/segments/_actions.ts::createSegment. Filter validity
// failures surface as 400 with the validator's first error message.
export function useCreateSegment() {
  const queryClient = useQueryClient();
  return useMutation<CreateSegmentResponse, ApiClientError, SegmentCreateInput>({
    mutationFn: (input) =>
      apiFetch<CreateSegmentResponse>("/settings/segments", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.segments() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to create segment");
    },
  });
}
